import React, { FunctionComponent, useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import * as S from './styled'
import { ReactComponent as UploadIcon } from '../../organisms/NoFilesPrompt/upload-icon.svg'

import useConnectRequest from '../../../hooks/useConnectRequest'
import { GET_USER_BY_UID } from '../../../redux/requests/auth/auth.actions'
require('dotenv').config()

type OwnProps = {
  documentView?: boolean
  files: File[]
  setFiles: React.Dispatch<React.SetStateAction<File[]>>
  setFileIsDuplicate: React.Dispatch<React.SetStateAction<boolean>>
  setRejectedFiles: React.Dispatch<React.SetStateAction<string[]>>
  listView: boolean
}

type Props = OwnProps

const MyDropzone: FunctionComponent<Props> = ({
  documentView = false,
  files,
  setFiles,
  setFileIsDuplicate,
  setRejectedFiles,
  listView,
}) => {
  const expandedView = files.length === 0 ? false : true
  const { loading: loadingMyUser } = useConnectRequest(GET_USER_BY_UID)

  const onDrop = useCallback(
    (acceptedFiles, fileRejections) => {
      if (acceptedFiles.length > 0) {
        const filteredFiles = acceptedFiles.filter(file => !files.some(f => file.name === f.name))
        const rejectedFiles = acceptedFiles.filter(
          file => !filteredFiles.some(f => file.name === f.name),
        )

        if (filteredFiles.length === acceptedFiles.length) {
          setFiles([...files, ...filteredFiles])
          setFileIsDuplicate(false)
        } else {
          setFiles([...files, ...filteredFiles])
          setRejectedFiles(rejectedFiles.map(file => file.name))
          setFileIsDuplicate(true)
        }
      } else {
        window.alert('Filtypen accepteras ej. Accepterade filtyper : PDF')
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [files],
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: '.pdf',
    onDrop,
  })

  return (
    <>
      {!listView && (
        <S.Container documentView={documentView} expandedView={expandedView}>
          {!loadingMyUser && (
            <>
              <div {...getRootProps()}>
                <S.DropArea documentView={documentView} expandedView={expandedView}>
                  <UploadIcon />
                  <input {...getInputProps()} />

                  {isDragActive ? (
                    <S.Text2>Släpp filen här ...</S.Text2>
                  ) : (
                    <S.Text2>
                      Dra och släpp filer här, <br /> eller klicka för att välja filer
                    </S.Text2>
                  )}
                </S.DropArea>
              </div>
            </>
          )}
        </S.Container>
      )}
      {listView && (
        <S.ListContainer documentView={documentView} expandedView={expandedView}>
          {!loadingMyUser && (
            <>
              <div {...getRootProps()}>
                <S.DropArea documentView={documentView} expandedView={expandedView}>
                  <UploadIcon />
                  <input {...getInputProps()} />

                  {isDragActive ? (
                    <S.Text2>Släpp filen här ...</S.Text2>
                  ) : (
                    <S.Text2>
                      Dra och släpp filer här, <br /> eller klicka för att välja filer
                    </S.Text2>
                  )}
                </S.DropArea>
              </div>
            </>
          )}
        </S.ListContainer>
      )}
    </>
  )
}

export default MyDropzone
